import { overlay } from './overlay';
import { button } from './button';
import { quickstart } from './quickstart';
import type { OverlayHandlerBuilder } from './types';
import type { VippsButtonBuilder } from './types';
import type { QuickstartBuilder } from './types';
import type { CreateSessionFn } from './types';

const vipps = {
  button,
  overlay,
  quickstart,
};

declare global {
  interface Window {
    vipps: typeof vipps;
  }
}

if (typeof window !== 'undefined') {
  window.vipps = vipps;
}

export { vipps };
export type { OverlayHandlerBuilder, VippsButtonBuilder, QuickstartBuilder, CreateSessionFn };
